export const faqs = [
  {
    panel: "panel1",
    title: "What is a Superfluid stream?",
    info: "A Superfluid stream is a smart contract that allows for the continuous and adjustable flow of tokens between two parties, with the flow rate and duration of the stream set at creation.",
  },
  {
    panel: "panel2",
    title: "What tokens can be transferred in a Superfluid stream?",
    info: "Any ERC-20 token can be transferred in a Superfluid stream.",
  },
  {
    panel: "panel3",
    title: "Can I update a Superfluid stream after it has been created?",
    info: "Yes, if stream is active or scheduled then you can update a Superfluid stream by changing the flow rate, start(if not started) and end dates.",
  },
  {
    panel: "panel4",
    title: "Can I delete a Superfluid stream after it has been created?",
    info: "Yes, you can delete a Superfluid stream at any time.",
  },
  {
    panel: "panel5",
    title:
      "How does the selection of a token work in the Superfluid stream creation process?",
    info: "When creating a Superfluid stream, users can select which token they want to transfer by choosing from a list of available ERC-20 tokens.",
  },
  {
    panel: "panel6",
    title: "Can I create multiple Superfluid streams at once?",
    info: "Yes, you can create and manage multiple Superfluid streams from a single interface.",
  },
  {
    panel: "panel7",
    title: "Can I use Superfluid streams for recurring payments?",
    info: "Yes, Superfluid streams are an ideal solution for recurring payments, as they allow for continuous and adjustable token transfers over a specified period of time.",
  },
  {
    panel: "panel8",
    title: "How does Gelato automation work with Streamify?",
    info: "Gelato automation integrates seamlessly with Streamify to provide efficient and reliable automated payment processes. By utilizing Gelato's gasless transaction feature, Streamify reduces the need for users to pay gas fees when interacting with their Superfluid streams.",
  },
  // Add more FAQs as needed
];
